import type { ProjectGraphResponse } from '@avisoma/shared';

/** Why the canvas has nothing to draw (see `emptyState`). */
export type EmptyState = 'noDocuments' | 'noEntities' | 'filtered';

const ENTITY_KINDS: ReadonlySet<string> = new Set(['engine', 'aircraft', 'part', 'reference']);

export const EMPTY_MESSAGE: Record<EmptyState, string> = {
  noDocuments: 'This project has no documents yet.',
  noEntities: "No entities have been extracted from this project's documents yet.",
  filtered: 'Nothing to show with the current filters.',
};

/**
 * Why the view is empty, or `null` when it is not: the project has no document, or its documents name no entity,
 * or a filter is on (`filtersOn`) and the view shows no node besides its root (`visibleCount`, the visible nodes
 * other than the root). With no filter on, a root with nothing to show (a document that names no entity) still
 * draws as a lone card.
 */
export function emptyState(graph: ProjectGraphResponse, visibleCount: number, filtersOn: boolean): EmptyState | null {
  if (!graph.nodes.some((n) => n.kind === 'document')) return 'noDocuments';
  if (!graph.nodes.some((n) => ENTITY_KINDS.has(n.kind))) return 'noEntities';
  return filtersOn && visibleCount === 0 ? 'filtered' : null;
}
